<!--modal approve-->
<app-modal #modalConfirm [callbackSubmit]="submitForm" [modalConfig]="modalConfig">
  <div *ngIf="detailView === 'edit-request'; else defaultModal" class="text-center">
    Dengan menyetujui, data retailer akan <b>diperbarui</b>.<br />
    Pastikan semua data telah lengkap dan benar.
  </div>
  <ng-template #defaultModal>
    <div class="text-center">
      Data retailer yang disetujui akan berubah menjadi <b>terverifikasi</b>. Pastikan semua data
      telah lengkap dan benar.
    </div>
  </ng-template>
</app-modal>

<!--approve success-->
<app-modal
  #modalResponseAfterApprove
  [callbackDetail]="toDetail"
  [callbackSubmit]="closeModalResponseAfterApprove"
  [modalConfig]="modalConfigResponseApprove"
  [modalOptions]="modalOptionResponseApprove"
>
  <div
    *ngIf="responseApproval && detailView === 'default'; else editRequestViewAfterApprove"
    class="d-flex alig flex-column justify-content-center align-items-center"
  >
    <span [inlineSVG]="iconSuccess" class="mb-6"></span>
    <div class="text-center d-flex flex-column">
      <span>Verifikasi retailer berhasil.</span>
      <span>Akses login retailer {{ responseApproval.name }}:</span>
    </div>

    <div class="group_user_password">
      <div class="my-5 d-flex w-100 justify-content-center align-items-center on_copy_password">
        <div class="d-flex flex-column justify-content-center align-items-center">
          <strong class="text-center">{{ responseApproval.email }}</strong>
          <span class="d-flex gap-3">
            <strong class="text-center">{{ responseApproval.password }}</strong>
            <div ngbPopover="Email & Password berhasil di copy" placement="top" type="button">
              <span
                (click)="copyToClipboard(responseApproval.email, responseApproval.password)"
                [inlineSVG]="iconCopy"
                class="cursor-pointer"
              ></span>
            </div>
          </span>
        </div>
      </div>
    </div>

    <div class="text-center mb-5">
      <span
        >Marketing Executive: {{ responseApproval.sales_name }}
        {{ '(' + responseApproval.sales_phone + ')' }}</span
      >
    </div>

    <app-note-view
      [color]="'secondary'"
      [icon]="iconInfo"
      [text]="'Pastikan password berhasil dicopy sebelum menutup pop up.'"
    ></app-note-view>
  </div>

  <ng-template #editRequestViewAfterApprove>
    <div class="d-flex alig flex-column justify-content-center align-items-center">
      <span [inlineSVG]="iconSuccess" class="mb-6"></span>
      <div class="text-center">Permintaan pembaruan data retailer berhasil disetujui.</div>
    </div>
  </ng-template>
</app-modal>

<!--modal after reject-->
<app-modal
  #modalResponseAfterReject
  [callbackDetail]="toDetailReject"
  [callbackSubmit]="closeModalResponse"
  [modalConfig]="modalConfigResponse"
>
  <div class="d-flex flex-column justify-content-center align-items-center">
    <span [inlineSVG]="iconSuccess"></span>
    <div>
      {{
        detailView === 'edit-request'
          ? 'Permintaan pembaruan data retailer berhasil ditolak.'
          : 'Retailer berhasil ditolak.'
      }}
    </div>
  </div>
</app-modal>

<!--modal reject-->
<app-modal
  #modalReject
  [callbackSubmit]="submitForm"
  [modalConfig]="modalConfigReject"
  [modalOptions]="{ size: 'md' }"
>
  <div>
    <p>{{ getRejectModalHeading() }}</p>
    <ng-container *ngIf="listRejectEnum | async as rejectEnum">
      <form (ngSubmit)="submitForm()" [formGroup]="formReject">
        <ul class="list-unstyled">
          <ng-container formArrayName="reject_enum">
            <li *ngFor="let item of rejectEnum; let i = index">
              <div class="form-check mb-4 d-flex align-items-center">
                <input
                  [formControlName]="i"
                  [value]="item.enum_value"
                  class="form-check-input cursor-pointer"
                  id="{{ item.enum_value }}"
                  type="checkbox"
                />
                <label
                  [for]="item.enum_value"
                  class="form-check-label cursor-pointer ms-4 text-gray-800"
                  >{{ item.enum_string }}</label
                >
              </div>
            </li>
          </ng-container>
          <li *ngIf="optionOtherSelected()">
            <textarea
              class="form-control form-control-solid min-h-100px"
              cols="10"
              formControlName="reject_reason"
              placeholder="Silahkan input alasan penolakan"
            ></textarea>
          </li>
        </ul>
      </form>
    </ng-container>
  </div>
</app-modal>

<app-modal
  #modalConfirmReset
  [callbackSubmit]="submitResetPassword"
  [modalConfig]="modalConfirmResetConfig"
>
  <div class="text-center">Password dari retailer {{ detail.value?.venture_name }}</div>
  <div class="text-center">({{ detail.value?.owner_email }} ) akan direset.</div>
  <div class="text-center">Apakah anda yakin?</div>
</app-modal>

<app-modal
  #modalResetPassword
  [callbackSubmit]="closeModalResponseResetPassword"
  [modalConfig]="modalResponseResetConfig"
>
  <div class="d-flex flex-column justify-content-center align-items-center text-center">
    <span [inlineSVG]="iconSuccess" class="mb-6"></span>
    <div>Password berhasil direset.</div>
    <div>
      Password dari retailer {{ detail.value?.venture_name }} ({{
        responseResetPassword.value?.username
      }}):
    </div>
    <div class="group_user_password">
      <div
        *ngIf="responseResetPassword.value?.password"
        class="mt-5 d-flex w-100 justify-content-center on_copy_password align-items-center"
      >
        <strong class="text-center">{{ responseResetPassword.value?.password }}</strong>
        <div class="d-flex" ngbPopover="Password berhasil di copy" placement="top" type="button">
          <span
            (click)="copyToClipboard(responseResetPassword.value?.password ?? '')"
            [inlineSVG]="STRING_CONSTANTS.ICON.IC_COPY"
            class="cursor-pointer"
          ></span>
        </div>
      </div>
    </div>
    <div class="mt-5">
      Marketing Executive: {{ detail.value?.pic_marketing?.name }} ({{
        detail.value?.pic_marketing?.phone
      }})
    </div>
    <div class="mt-5 notif">
      <div class="notif-left">
        <span [inlineSVG]="iconInfo"></span>
      </div>
      <div class="notif-right">Pastikan password berhasil dicopy sebelum menutup pop up.</div>
    </div>
  </div>
</app-modal>

<app-modal-non-active-customer #modalNonActiveCustomer [customerType]="'retailer'" />

<div
  *ngIf="status === 'terverifikasi' && tab !== 'nonactive' && privilegeCta.value?.[2]"
  class="d-flex align-items-center position-absolute top-0 end-0 m-9 mt-6"
>
  <!--begin::Action menu-->
  <a
    class="btn btn-outline btn-outline-primary ps-7 mb-2"
    data-kt-menu-attach="parent"
    data-kt-menu-placement="bottom-end"
    data-kt-menu-trigger="click"
    href="#"
    >Actions
    <!--begin::Svg Icon | path: icons/duotune/arrows/arr072.svg-->
    <span class="svg-icon svg-icon-2 me-0">
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
          fill="currentColor"
        />
      </svg>
    </span>
    <!--end::Svg Icon-->
  </a>

  <!--begin::Menu-->
  <div
    class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold py-4 w-300px fs-6"
    data-kt-menu="true"
  >
    <!--begin::Menu item-->
    <div class="menu-item px-5" *ngIf="ableToRegisterMAC()">
      <div (click)="registerMAC()" class="menu-link">
        <span
          [inlineSVG]="STRING_CONSTANTS.ICON.IC_LOGO_MAC"
          class="svg-icon svg-icon-3 me-3"
        ></span>
        <span>Registrasi MAC</span>
      </div>
    </div>

    <div class="menu-item px-5" *ngIf="isSuperAdmin()">
      <div class="menu-link" (click)="modalInputQR.open()">
        <span
          [inlineSVG]="STRING_CONSTANTS.ICON.IC_QR_CODE"
          class="svg-icon svg-icon-2 me-3"
        ></span>
        <span>Manual Input QR</span>
      </div>
    </div>

    <div class="menu-item px-5">
      <div (click)="clickResetPassword()" *ngIf="privilegeCta.value?.[2]" class="menu-link">
        <span
          [inlineSVG]="STRING_CONSTANTS.ICON.IC_RESET_PASSWORD"
          class="svg-icon svg-icon-2 me-3"
        ></span>
        <span>Reset Password</span>
      </div>
    </div>

    <div class="menu-item px-5">
      <div class="menu-link" (click)="modalNonActiveCustomer.open()">
        <span
          [inlineSVG]="STRING_CONSTANTS.ICON.IC_REMOVE_USER"
          class="svg-icon svg-icon-2 me-3"
        ></span>
        <span>Nonaktifkan Retailer</span>
      </div>
    </div>
    <!--end::Menu item-->
  </div>
</div>

<!--reject list-->
<ng-container *ngIf="listReasonReject">
  <app-card-reject-reason
    [bodyList]="listReasonReject"
    [loading]="isLoading"
    [title]="'Alasan Penolakan'"
  ></app-card-reject-reason>
</ng-container>

<ng-container *ngIf="getStatusRetailerTerverifikasi() === RetailerStatus.nonactive">
  <app-card
    [borderHeader]="true"
    [border]="true"
    [cardClasses]="'mb-7 card-reason'"
    [cardHeaderTitle]="'Alasan Penonaktifan Retailer'"
    [header]="true"
  >
    <ng-container cardBody>
      <ul>
        <ng-container *ngFor="let item of listReasonNonactive">
          <li>{{ item }}</li>
        </ng-container>
      </ul>
    </ng-container>
  </app-card>
</ng-container>

<ng-container *ngIf="status !== 'terverifikasi' || detailView === 'log'; else defaultView">
  <app-card-profile-header
    [isLoading]="isLoading"
    [labelList]="labelList"
    [status]="{ string: detail.value?.status_string, value: detail.value?.status_value }"
    name="{{ detail.value?.venture_name }}"
  />

  <div class="row">
    <div *ngIf="detailView === 'edit-request' || detailView === 'log'" class="col-md-12 mt-7">
      <app-note-view
        [color]="'info-secondary'"
        [icon]="STRING_CONSTANTS.ICON.IC_INFO"
        [text]="'Perubahan data yang diajukan ditandai dengan warna biru. Silahkan periksa dan selesaikan proses approval pengajuan data.'"
      />
    </div>

    <div [class]="status === 'reject' || detailView === 'default' ? 'col-md-8 mt-7' : 'col-md-8'">
      <app-card-detail-body
        [bodyList]="detailRetailer"
        [cardClasses]="this.detail.value?.detail_retailer_new ? 'border border-primary' : ''"
        [loading]="isLoading"
        [titleInBody]="true"
        [title]="'Profil Retailer'"
      >
        <app-retailer-gmap [data]="generateMapData('owner')" [loading]="isLoading" />
        <div class="mt-10" *ngIf="hasNewPinpoint(true)">
          <span class="fw-bold text-info-label d-block mb-n2">PinPoint Baru</span>
          <app-retailer-gmap [data]="generateMapData('owner', true)" [loading]="isLoading" />
        </div>
      </app-card-detail-body>
    </div>

    <div [class]="status === 'reject' || detailView === 'default' ? 'col-md-4 mt-7' : 'col-md-4'">
      <div *ngFor="let item of ownerKtpUpdate">
        <app-card [cardClasses]="ownerKtpUpdate.length > 1 ? 'mb-4 border border-primary' : 'mb-4'">
          <ng-container cardBody>
            <p class="h3 fw-bold mb-7">
              KTP Pemilik
              {{ ownerKtpUpdate.length > 1 ? (item.key === 'old' ? '(Lama)' : '(Baru)') : '' }}
            </p>
            <app-image-preview
              [height]="200"
              [image]="item.value ?? null"
              [openTextLabel]="false"
              [titleModal]="
                'KTP Pemilik ' +
                (ownerKtpUpdate.length > 1 ? (item.key === 'old' ? '(Lama)' : '(Baru)') : '')
              "
            ></app-image-preview>
          </ng-container>
        </app-card>
      </div>
    </div>
  </div>

  <hr class="my-8 border-gray-300" />

  <!--Section: Informasi Usaha-->
  <app-card-detail-body
    [bodyList]="detailVenture"
    [title]="'Informasi Usaha'"
    [loading]="isLoading"
    [cardClasses]="ventureHasNewData() ? 'border border-primary' : ''"
    [titleInBody]="true"
  >
    <app-retailer-gmap [data]="generateMapData('venture')" [loading]="isLoading" />
    <div class="mt-10" *ngIf="hasNewPinpoint(false)">
      <span class="fw-bold text-info-label d-block mb-n2">PinPoint Baru</span>
      <app-retailer-gmap [data]="generateMapData('venture', true)" [loading]="isLoading" />
    </div>
  </app-card-detail-body>

  <hr class="my-8 border-gray-300" />

  <div class="row">
    <div
      *ngIf="detailView === 'edit-request' || detailView === 'log'; else DocumentDefault"
      class="col-12 mb-7"
    >
      <app-card [cardClasses]="chekInHasNewValue()">
        <ng-container cardBody>
          <p class="h3 fw-bold mb-7">Dokumen</p>
          <div
            *ngFor="let item of displayConfidentialDocuments; last as last"
            class="row"
            [class.mb-3]="!last"
          >
            <div class="col-md-6 my-3">
              <div class="row">
                <div class="col-md-3">
                  <p class="text-gray-700 mw-125px">
                    {{ item.label }}
                    {{ item.key === 'owner_ktp_selfie_image_url' ? 'dengan KTP' : ''
                    }}{{ item?.new ? '(Lama)' : '' }} :
                  </p>
                </div>
                <div class="col-md-9">
                  <app-image-preview
                    [height]="200"
                    [image]="item.value ?? null"
                    [openTextLabel]="false"
                    [titleModal]="item.label + (item?.new ? '(Lama)' : '')"
                  ></app-image-preview>
                </div>
              </div>
            </div>
            <div *ngIf="item && item.new" class="col-md-6">
              <div class="row">
                <div class="col-md-3">
                  <p class="text-info fw-bold">
                    {{ item.label }}
                    {{ item.key === 'owner_ktp_selfie_image_url' ? 'dengan KTP' : '' }} (Baru) :
                  </p>
                </div>
                <div class="col-md-9">
                  <app-image-preview
                    [height]="200"
                    [image]="item.new ?? ''"
                    [openTextLabel]="false"
                    [titleModal]="item.label + '(Baru)'"
                  ></app-image-preview>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </app-card>
    </div>

    <ng-template #DocumentDefault>
      <app-card-document
        [bodyList]="detailDocument"
        [loading]="isLoading"
        [title]="'Dokumen'"
      ></app-card-document>
    </ng-template>

    <div *ngIf="hasDocumentPembaruanList()" class="col-12">
      <app-card [cardClasses]="'border border-primary mb-4'">
        <ng-container cardBody>
          <p class="h3 fw-bold mb-7">Dokumen Pembaruan</p>
          <p class="text-gray-800">
            {{ detail.value?.document_pembaruan_list?.[0]?.uploaded_date }} :
          </p>
          <div class="d-flex justify-content-evenly gap-5">
            <div *ngFor="let value of detail.value?.document_pembaruan_list?.[0]?.url">
              <app-image-preview
                [height]="200"
                [image]="value"
                [openTextLabel]="false"
                [titleModal]="'Dokumen Pembaruan'"
              ></app-image-preview>
            </div>
          </div>
        </ng-container>
      </app-card>
    </div>
  </div>
</ng-container>

<ng-template #defaultView>
  <!--TAB-->
  <mat-tab-group animationDuration="0ms" class="line" mat-stretch-tabs="false">
    <ng-container *ngFor="let tab of privilegeTabs.value">
      <mat-tab *ngIf="tab.name === 'TAB_RETAILER_INFORMATION'" label="Informasi Retailer">
        <ng-template matTabContent>
          <app-card-profile-header
            [badge]="getBadge()"
            [isLoading]="isLoading"
            [labelList]="labelList"
            [status]="{ string: detail.value?.status_string, value: detail.value?.status_value }"
            name="{{ detail.value?.venture_name }}"
          />

          <!--Section PIC-->
          <app-card-detail-body
            *ngIf="detailRetailerPIC"
            [bodyList]="detailRetailerPIC"
            [loading]="isLoading"
            [titleInBody]="true"
            [title]="'PIC Marketing'"
          />

          <!--Section Profil Retailer -->
          <app-card-detail-body
            [bodyList]="detailRetailer"
            [loading]="isLoading"
            [titleInBody]="true"
            [title]="'Profil Retailer'"
          >
            <app-retailer-gmap [data]="generateMapData('owner')" [loading]="isLoading" />
          </app-card-detail-body>

          <!--Section Informasi Usaha -->
          <app-card-detail-body
            [bodyList]="detailVenture"
            [title]="'Informasi Usaha'"
            [loading]="isLoading"
            [titleInBody]="true"
          >
            <app-retailer-gmap [data]="generateMapData('venture')" [loading]="isLoading" />
          </app-card-detail-body>

          <!--Section Informasi Kemitraan -->
          <app-card-detail-body
            *ngIf="retailerIsMac()"
            [bodyList]="getMacInfo()"
            [loading]="isLoading"
            [titleInBody]="true"
            [title]="'Informasi Kemitraan'"
          />
        </ng-template>
      </mat-tab>

      <mat-tab *ngIf="tab.name === 'TAB_RETAILER_DOCUMENT'" label="Dokumen">
        <ng-template matTabContent>
          <div [className]="'mb-7'">
            <app-card-document
              [bodyList]="detailDocument"
              [loading]="isLoading"
              [title]="'Dokumen'"
            />
          </div>
          <app-card
            *ngIf="getStatusRetailerTerverifikasi() === RetailerStatus.nonactive"
            [cardClasses]="'mb-7'"
          >
            <ng-container cardBody>
              <p class="h3 fw-bold mb-7">Dokumen Penonaktifan</p>
              <app-document-preview
                [customClass]="'d-flex flex-wrap gap-8'"
                [data]="documentNonactive.value"
              />
            </ng-container>
          </app-card>
        </ng-template>
      </mat-tab>

      <mat-tab *ngIf="tab.name === 'TAB_RETAILER_DOCUMENT'" label="Program Marketing">
        <ng-template matTabContent>
          <app-program-marketing-list></app-program-marketing-list>
        </ng-template>
      </mat-tab>

      <mat-tab *ngIf="tab.name === 'TAB_RETAILER_DOCUMENT'" label="Log">
        <ng-template matTabContent>
          <!--          <app-card-log-legacy [emptyStateText]="'Belum terdapat data retailer.'" [urlDataApi]="API.LIST_LOG_RETAILER"/>-->
          <app-card-log [config]="logConfig" [context]="logContext" />
        </ng-template>
      </mat-tab>

      <!--    Reward No Integration-->
      <!--    <mat-tab label="Reward">-->
      <!--      <app-retailer-reward></app-retailer-reward>-->
      <!--    </mat-tab>-->
    </ng-container>
  </mat-tab-group>
</ng-template>

<div
  *ngIf="
    (privilegeCta.value?.[0] || privilegeCta.value?.[1]) &&
    status?.toUpperCase() === retailerStatusEnum.pending &&
    detailView !== 'log'
  "
  class="d-flex justify-content-end align-items-center mt-6 mb-18"
>
  <div class="action-button-right d-flex justify-content-end align-items-center">
    <button
      (click)="handleReject()"
      *ngIf="privilegeCta.value?.[1]"
      class="btn btn-outline btn-outline-danger"
    >
      Tolak
    </button>
    <button (click)="handleApprove()" *ngIf="privilegeCta.value?.[0]" class="btn btn-primary ms-4">
      Setujui
    </button>
  </div>
</div>

<app-modal-form #modalInputQR [modalConfig]="modalInputQRConfig">
  <div class="fs-7 mb-4">
    Silahkan masukkan kode yang tertera pada QR dengan benar. Kode yang dimasukan akan dihitung
    sebagai poin scan Retailer.
  </div>
  <form [formGroup]="formInputQr">
    <fieldset [disabled]="isLoading.value">
      <input
        placeholder="Input kode QR barang"
        formControlName="qr_code"
        class="form-control form-control-solid"
        [value]="qrCodeInput?.value?.toUpperCase()"
        [ngClass]="{ 'is-invalid border border-danger': formInputQr.invalid && formInputQr.dirty }"
      />
    </fieldset>
    <div class="mt-2 text-danger" *ngIf="formInputQr.invalid && formInputQr.dirty">
      <span *ngIf="formInputQr.controls.qr_code.errors" class="fs-8"
        >Kode QR tidak valid, silahkan periksa ulang dan input lagi.</span
      >
    </div>
  </form>

  <div class="mt-8 d-flex flex-nowrap align-items-center">
    <button
      type="button"
      mat-button
      class="btn btn-outline btn-outline-secondary text-primary w-100 me-lg-3"
      (click)="modalInputQR.close()"
    >
      {{ modalInputQRConfig.closeButtonLabel }}
    </button>
    <button
      type="button"
      mat-button
      class="btn w-100 btn-primary text-white"
      [disabled]="modalInputQRConfig.disableDismissButton?.() ?? false"
      (click)="onSubmitInputQr()"
    >
      {{ modalInputQRConfig.dismissButtonLabel }}
    </button>
  </div>
  <app-fullscreen-loader *ngIf="isLoading | async" />
</app-modal-form>
